import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { flexBoxCenter } from '../../../styles/commonStyles';
import OverSightDisplayBox from '../../common/OverSightDisplayBox';

const OverSightHP = ({ dataAccessKey }) => {
  const segmentsData = [];

  const [localData, setLocalData] = useState([]);

  useEffect(() => {
    if (segmentsData.length > 0 && dataAccessKey) {
      const filteredData = segmentsData.filter(
        (data) => data.id === dataAccessKey
      );
      setLocalData(...filteredData);
    }
  }, []);

  return (
    <Wrapper>
      {/* Title */}
      <OverSightDisplayBox isMainTitle={true} />
      {/* Display segment Section */}
      {localData.data?.map((segmentData, segmentIdx) => (
        <OverSightDisplayBox
          dataAccessKey={localData.id}
          key={segmentData.id}
          openingId={segmentData.id}
          segNum={segmentData.segNum}
          title={segmentData.title}
          consumption={segmentData.consumption}
          usage={segmentData.usage}
          isOn={segmentData.isOn}
        />
      ))}
    </Wrapper>
  );
};

export default OverSightHP;

const Wrapper = styled.div`
  ${flexBoxCenter}
  flex-direction: column;
  gap: 6px;
  padding: 10px;
`;
